import * as React from 'react';

import { useParams } from 'js/lib/useRouter';

import ConsumerPathwayRoleRelatedDegreeCollectionContext from 'bundles/unified-career-academy/contexts/ConsumerPathwayRoleRelatedDegreeCollectionContext';
import { useRelatedDegrees } from 'bundles/unified-career-academy/hooks/useRelatedDegrees';

type Props = {
  children: React.ReactNode;
};

const ConsumerPathwayRoleRelatedDegreeCollectionProvider = ({ children }: Props) => {
  const { roleSlug } = useParams();

  const hasValidSlug = typeof roleSlug === 'string' && roleSlug.trim().length > 0;
  const { data, loading } = useRelatedDegrees({
    slug: hasValidSlug ? roleSlug : '',
    ssr: false,
    skip: !hasValidSlug,
  });

  return (
    <ConsumerPathwayRoleRelatedDegreeCollectionContext.Provider
      value={{
        relatedDegrees: data,
        relatedDegreesLoading: loading,
      }}
    >
      {children}
    </ConsumerPathwayRoleRelatedDegreeCollectionContext.Provider>
  );
};

export default ConsumerPathwayRoleRelatedDegreeCollectionProvider;
